<template>
    <div class="container max-w-md mx-auto text-center py-6">
        <div>
            <h2 class="pt-4 pb-2" v-text="$t('THANK_YOU_FANTASTIC')"></h2>
            <p v-html="$t('THANK_YOU_SURE', {
                'address.first_name': $t(`${address && address.first_name}`)})"></p>
            <p>
                {{ $t('THANK_YOU_THE_BOX') }} <strong v-text="firstDeliveryDate"></strong>.
            </p>
        </div>
        <div class="pt-2">
            <p v-html="$t('THANK_YOU_IF_YOU', {contactNumber})"></p>
            <p>
                {{ $t('THANK_YOU_YOUR_ORDER') }}
                <span class="font-bold" v-text="giftReference"></span>,
                {{ $t('THANK_YOU_EMAILED_YOU') }}
            </p>
            <div class="border border-black p-6 pb-10 my-6">
                <p v-html="$t('THANK_YOU_IF_YOU_LIKE_SOMETHING', {
                'address.first_name': $t(`${address && address.first_name}`)})"></p>
                <p v-text="$t('THANK_YOU_JUST_PRINT')"></p>
                <a class="btn btn--primary mt-3" target="_blank" :href="giftNoteUrl"
                    v-text="$t('THANK_YOU_DOWNLOAD')"></a>
            </div>
            <router-link
                class="link"
                :to="{'name': 'account.gifting.choose-your-gift'}"
                v-text="$t('THANK_YOU_SEND_ANOTHER')"></router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ThankYou',
    data() {
        return {
            contactNumber: process.env.VUE_APP_TELEPHONE,
        };
    },
    mounted() {
        if (this.hasProcessed === false) {
            // redirect to payment
            this.$router.push({ name: 'account.gifting.payment' });
        }
    },
    computed: {
        hasProcessed() {
            return this.$store.getters['gifting/hasProcessed'];
        },

        address() {
            return this.$store.getters['address/getSelectedGiftingAddress'];
        },

        firstDeliveryDate() {
            let date = this.$store.getters['gifting/getDeliveryDateSelected'] || '2001-01-01';

            return this.$moment(date).format('dddd Do MMMM');
        },

        giftReference() {
            return this.$store.getters['gifting/getGiftReference'];
        },

        giftNoteUrl() {
            return this.$store.getters['gifting/getGiftNoteUrl'];
        },
    },
};
</script>
